<template>
  <v-container class="py-8" style="max-width: 960px">
    <v-row align="center" class="mb-4">
      <v-col>
        <h1 class="text-h4 font-weight-bold grey--text text--darken-3">Mis estudios</h1>
        <div class="text-subtitle-1 grey--text text--darken-1">
          Acá podés descargar los estudios en PDF que tu médico cargó en tu historia clínica.
        </div>
      </v-col>
      <v-col cols="auto">
        <v-btn icon @click="cargar" :loading="loading" aria-label="Actualizar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>

    <v-card outlined class="rounded-lg">
      <v-list v-if="archivos.length" two-line>
        <template v-for="(archivo, i) in archivos">
          <v-divider v-if="i > 0" :key="'d' + archivo.id"></v-divider>
          <v-list-item :key="archivo.id">
            <v-list-item-avatar>
              <v-icon color="red darken-1">mdi-file-pdf-box</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ archivo.titulo }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ fecha(archivo.fecha_estudio || archivo.fecha_carga) }}
                <span v-if="archivo.descripcion"> · {{ archivo.descripcion }}</span>
                <span v-if="archivo.tamano"> · {{ tamano(archivo.tamano) }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn color="primary" depressed small :loading="descargando === archivo.id"
                     @click="descargar(archivo)">
                <v-icon left small>mdi-download</v-icon>
                Descargar
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <v-card-text v-else-if="!loading" class="text-center grey--text py-8">
        <v-icon size="48" color="grey lighten-1">mdi-file-document-outline</v-icon>
        <div class="mt-2">Todavía no tenés estudios cargados.</div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { getMisEstudios, descargarMiEstudio, formatearTamano, mensajeError } from '@/services/estudiosArchivos';

export default {
  name: 'MisEstudios',
  data() {
    return { archivos: [], loading: false, descargando: null, error: '' };
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      this.error = '';
      try {
        this.archivos = await getMisEstudios();
      } catch (e) {
        this.error = mensajeError(e, 'No se pudieron cargar tus estudios.');
      } finally {
        this.loading = false;
      }
    },
    async descargar(archivo) {
      this.descargando = archivo.id;
      this.error = '';
      try {
        await descargarMiEstudio(archivo);
      } catch (e) {
        this.error = 'No se pudo descargar el archivo.';
      } finally {
        this.descargando = null;
      }
    },
    fecha(valor) {
      return valor ? new Date(valor).toLocaleDateString('es-AR') : '';
    },
    tamano: formatearTamano
  }
};
</script>
